import React from 'react';

import css from './BackButton.module.scss';

interface Props {
  onClick: () => void;
}

const BackButton = ({ onClick }: Props) => {
  return (
    <button
      className={css.backButton}
      onClick={onClick}
      data-e2e="back-button"
      data-testid="back-button"
    >
      <img
        className={css.backDesktop}
        src="/static/back-arrow.svg"
        alt="Back Button"
      />
      <img
        className={css.backMobile}
        src="/static/back-arrow-mobile.svg"
        alt="Back Button"
      />
    </button>
  );
};

export default BackButton;
